<template>
  <div class="zj-login-page">
    <zj-startup :percent="startup.percent" :msg="startup.msg" />
  </div>
</template>

<script>
import utils from "../utils";
import permissionsApi from "../request/permissionsApi";
import WebSocketApi from "../websoket/intercomWebsocket";
const strNumber = global.$config.api.strNumber;
const strPassword = global.$config.api.strPassword;
const strLocalIP = global.$config.api.strLocalIP;
const strServer = global.$config.api.strServer;

export default {
  name: "ZjNoLogin",
  data() {
    return {
      startup: {
        percent: 0,
        msg: "启动中...",
      },
      isIgnoreLogin: false,
      interval: 0, //加载的定时器
      timeStop: 0, //加载成功停止的定时器
      LoginSend: {
        strNumber: strNumber,
        strPassword: strPassword,
        strLocalIP: strLocalIP,
        strServer: strServer,
      },
    };
  },
  created() {
    if (
      !this.isLogin &&
      (this.getQueryString("userName") == undefined ||
        this.getQueryString("userName") == "" ||
        this.getQueryString("userName") == null)
    ) {
      var mainUrl = "https://sso.xjtstc.com/tsscdataview";
      window.location.href = mainUrl;
    } else {
      this.login();
    }
  },
  methods: {
    // 登录
    login() {
      this.isIgnoreLogin = true;
      let loginInfo = {
        LoginName: this.getQueryString("userName"),
        perSystemCode: this.getQueryString("perSystemCode"),
        perProjectCode: this.getQueryString("perProjectCode"),
        vtoken: utils.uuid(),
      };

      this.ssoPermissionsApi(loginInfo);
    },

    // 登录成功
    onLogin(user, loginInfo) {
      this.startup.percent = 100;
      this.user.setUser(user, loginInfo.LoginPwd);
      localStorage.setItem("isIgnoreLogin", true);
      //如果是应急平台则不弹出消息弹窗
      if (
        this.getQueryString("perSystemCode") == this.CNF("app.perYJSystemCode")
      ) {
        localStorage.setItem("isEmergency", true);
      } else {
        localStorage.setItem("isEmergency", false);
      }
      this.$emit("login", user);
      this.logInfo.ActionName = "登录";
      this.logInfo.LogMessage = "登录成功";
      this.logInfo.ModuleName = "登录";
      this.logInfo.PageName = "登录";
      this.addOperationLog();
      this.InitWebSocket();
    },
    //登录融合通讯
    InitWebSocket() {
      this.ws = WebSocketApi.OpenWebsoket(this.LoginSend);
    },
    ssoPermissionsApi(loginInfo) {
      let that = this;
      let endPro = 95;
      that.interval = setInterval(function () {
        if (that.startup.percent < endPro) {
          that.startup.percent++;
        }
      }, 500);
      let param = {
        userName: loginInfo.LoginName,
        perSystemCode: loginInfo.perSystemCode,
        perProjectCode: loginInfo.perProjectCode,
      };
      permissionsApi
        .ssoPermission(param)
        .then((res) => {
          if (res.code == 0) {
            let user = {};
            user.UserName = res.data.user.name || "";
            user.UserId = res.data.user.code || "";
            user.LoginName = res.data.user.userName || "";
            user.userInfo = res.data || {};
            loginInfo.LoginPwd = res.data.user.password || "";
            this.onLogin(user, loginInfo);
          } else {
            this.startup.percent = 0;
            this.startup.msg = "启动失败";
            console.log(res.msg);
          }
        })
        .catch((e) => {
          console.error(e);
          this.startup.percent = 0;
          this.startup.msg = "服务异常，请联系管理员！";
        });
    },
    getQueryString(name) {
      const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      const r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return decodeURI(r[2]);
      }
    },
  },
};
</script>
